import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as ConversationActions from '../conversation/actions';
import * as InboxMessageComposerActions from '../inbox-message-composer/actions';
import * as Actions from './actions';

export class InboxMainState extends Record<{
    conversationId: string;
    messagesToForward: string[];
}>({
    conversationId: '',
    messagesToForward: [],
}) {}

export default makeReducer<InboxMainState>(
    [
        match(Actions.selectConversation, (state, {payload}) =>
            state.merge({
                conversationId: payload.conversationId,
                messagesToForward: payload.messagesToForward ? payload.messagesToForward : state.messagesToForward,
            }),
        ),
        match(InboxMessageComposerActions.sendNewSuccess, (state, {payload}) =>
            state.merge({
                conversationId: payload.newMessage.conversationId,
            }),
        ),
        match(Actions.reset, () => new InboxMainState()),
        match(ConversationActions.leaveConversationSuccess, () => new InboxMainState()),
        match(Actions.clearMessagesToForward, state =>
            state.merge({
                messagesToForward: [],
            }),
        ),
    ],
    new InboxMainState(),
);
